import {Outlet} from 'react-router-dom'
import {useViewAs} from '@/hooks/platform/use-view-as'

/** Remounted on every lens change: pages copy what they fetch into local state once,
 * so a refetch alone would keep the previous person's answers (KAI-8). */
export function LensOutlet() {
  const {target} = useViewAs()
  return <Outlet key={target?.id ?? 'propio'} />
}
